import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Trophy, Plus, Users, Calendar, ChevronRight, Loader2, Swords } from "lucide-react";
import { Button } from "../components/ui/button";
import api from "../lib/api";

export default function Tournaments() {
  const [tournaments, setTournaments] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchTournaments = async () => {
      try {
        const response = await api.getTournaments();
        setTournaments(response.data);
      } catch (error) {
        console.error("Error fetching tournaments:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchTournaments();
  }, []);

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-[60vh]">
        <Loader2 className="w-8 h-8 text-[#4DFFFF] animate-spin" />
      </div>
    );
  }

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-testid="tournaments-page">
      <div className="flex items-center justify-between mb-8">
        <div>
          <h1 className="text-3xl font-bold font-['Barlow_Condensed'] uppercase tracking-wider text-white">
            Turnuvalar
          </h1>
          <p className="text-[#B1C1C1] mt-1">Tek ve çift eleme turnuvaları</p>
        </div>
        <Link to="/create-tournament">
          <Button className="bg-[#4DFFFF] text-[#050E2E] hover:bg-[#4DFFFF]/90 font-['Barlow_Condensed'] uppercase tracking-wider font-bold">
            <Plus className="w-4 h-4 mr-2" />
            Yeni Turnuva
          </Button>
        </Link>
      </div>

      {tournaments.length === 0 ? (
        <div className="glass-card p-12 text-center">
          <Swords className="w-16 h-16 text-[#C6A87C] mx-auto mb-4 opacity-50" />
          <p className="text-[#B1C1C1] text-lg">Henüz turnuva yok</p>
          <p className="text-sm text-[#64748B] mt-2">İlk turnuvayı oluşturmak için butona tıklayın</p>
          <Link to="/create-tournament">
            <Button className="mt-4 bg-[#4DFFFF] text-[#050E2E] hover:bg-[#4DFFFF]/90">
              <Plus className="w-4 h-4 mr-2" />
              Turnuva Oluştur
            </Button>
          </Link>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {tournaments.map((tournament, index) => (
            <Link
              key={tournament.tournament_id}
              to={`/tournament/${tournament.tournament_id}`}
              className="glass-card glass-card-hover overflow-hidden animate-fade-in-up"
              style={{ animationDelay: `${index * 0.05}s` }}
            >
              <div className="bg-gradient-to-r from-[#C6A87C]/20 to-transparent px-6 py-4 border-b border-white/10">
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-3">
                    <Swords className="w-5 h-5 text-[#C6A87C]" />
                    <span className="font-['Barlow_Condensed'] uppercase tracking-wider text-white font-bold">
                      {tournament.name}
                    </span>
                  </div>
                  <span className={`px-2 py-1 rounded text-xs font-bold ${
                    tournament.status === "completed" 
                      ? "bg-green-500/20 text-green-400" 
                      : "bg-[#4DFFFF]/20 text-[#4DFFFF]"
                  }`}>
                    {tournament.status === "completed" ? "Tamamlandı" : "Aktif"}
                  </span>
                </div>
              </div>
              
              <div className="p-6">
                <div className="flex items-center gap-4 mb-4">
                  <span className="text-[#B1C1C1]">{tournament.game_name}</span>
                  <span className="text-[#64748B]">•</span>
                  <span className="text-[#64748B]">
                    {tournament.tournament_type === "single_elimination" ? "Tek Eleme" : "Çift Eleme"}
                  </span>
                </div>
                
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-2">
                    <Users className="w-4 h-4 text-[#64748B]" />
                    <span className="text-sm text-[#B1C1C1]">{tournament.players?.length || 0} oyuncu</span>
                  </div>
                  
                  {tournament.winner_id && (
                    <div className="flex items-center gap-2">
                      <Trophy className="w-4 h-4 text-[#C6A87C]" />
                      <span className="text-sm text-[#C6A87C]">
                        {tournament.players?.find(p => p.user_id === tournament.winner_id)?.name || "Şampiyon"}
                      </span>
                    </div>
                  )}
                </div>

                <div className="flex items-center justify-end mt-4 pt-4 border-t border-white/5">
                  <span className="text-sm text-[#4DFFFF] flex items-center gap-1">
                    Detaylar
                    <ChevronRight className="w-4 h-4" />
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
